import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import * as Yup from 'yup';
import { renderRailsErrors } from "../../../utils/rails_error_parser";
import {
  TextInput,
  SelectInput,
} from "../../react-hook-form-inputs";
import {
  createAffiliation,
  updateAffiliation,
} from "../../../queries/company";

import {AFFILIATION_LABELS} from '../../../config/constants';

import './affiliation.scss';

const AffiliationSchema = Yup.object().shape({
  title: Yup.string().required(),
  email: Yup.string().email().required(),
});

export default function AffiliationForm({companyId, onSuccess, affiliation}) {
  const queryClient = useQueryClient();

  const action = affiliation?.id ? "edit" : "create";

  const defaultValues = {
    email: affiliation.email || '',
    title: affiliation.title || '',
  }

  const methods = useForm({
    resolver: yupResolver(AffiliationSchema),
    mode: "onTouched",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues,
  })

  const createMutation = useMutation(
    createAffiliation,
    {
      onSuccess: (affiliation) => {
        if (typeof onSuccess === 'function') onSuccess(affiliation)
        toast.success('Affiliation created.');
        queryClient.invalidateQueries(
          ["company-affilations-list", companyId],
          {
            exact: true,
          }
        )
      },
      onError: (error) => {
        renderRailsErrors(error)
      },
    }
  )

  const updateMutation = useMutation(
    updateAffiliation,
    {
      onSuccess: (affiliation) => {
        if (typeof onSuccess === 'function') onSuccess(affiliation)
        toast.success('Affiliation updated.');
        queryClient.invalidateQueries(
          ["company-affilations-list", companyId],
          {
            exact: true,
          }
        )
      },
      onError: (error) => {
        renderRailsErrors(error)
      },
    }
  )

  const onSubmit = (values) => {
    action === "create"
      ?
        createMutation.mutate({
          company_id: companyId,
          values: {affiliation: values}
        })
      :
        updateMutation.mutate({
          company_id: companyId,
          affiliation_id: affiliation.id,
          values: {affiliation: values}  
        })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <TextInput
          name="email"
          placeholder="Email"
          readOnly={ affiliation?.id ? true : false }
        />

        <SelectInput
          name="title"
          placeholder="Affliation Title"
        >
          <option value="">Select affiliation title</option>
          {
            AFFILIATION_LABELS.map(al => <option key={al.value} value={al.value}>{al.label}</option>)
          }
        </SelectInput>

        <div className="form-group d-flex">
          <button type="submit"
            className="ms-auto btn btn-outline-dark rounded-0 submit-btn"
            disabled={methods.isSubmitting}
          >
            { action === "create" ? "Create" : "Update"}
          </button>
        </div>
      </form>
    </FormProvider>
  )
}
